import { SlideConfig } from '../types';

/**
 * Configurazione delle slide del wizard Slider_Partnership_Email
 * 
 * Slide types:
 * - FORM_INPUT: Form con input fields
 * - INFO: Slide informativa (loading, success, error)
 */
export const SLIDES_CONFIG: SlideConfig[] = [
  // ============================================
  // SLIDE 1: Form Contatti Unificato
  // ============================================
  {
    id: 'contact_form',
    type: 'FORM_INPUT',
    subtitle: 'I nostri consulenti ti contatteranno entro 24H',
    title: 'Inserisci i tuoi dati per prenotare la tua consulenza tecnica',
    inputs: [
      {
        name: 'name',
        placeholder: 'Nome e Cognome',
        type: 'text',
        required: true,
      },
      {
        name: 'email',
        placeholder: 'Email',
        type: 'email',
        required: true,
      },
      {
        name: 'phone',
        placeholder: 'Numero di telefono',
        type: 'tel',
        required: true,
        pattern: '^[\\d\\s]{10,18}$',
      },
    ],
  },

  // ============================================
  // SLIDE 2: Loading
  // ============================================
  {
    id: 'loading',
    type: 'INFO',
    title: 'Invio della richiesta in corso...',
    html: '<p>Attendere prego...</p>',
  },

  // ============================================
  // SLIDE 3: Success
  // ============================================
  {
    id: 'success',
    type: 'INFO',
    title: '',
  },

  // ============================================
  // SLIDE 4: Error
  // ============================================
  {
    id: 'error',
    type: 'INFO',
    title: 'Oops, qualcosa è andato storto',
    html: '<p>Si è verificato un errore...</p>',
  },
];

/**
 * Trova l'indice di una slide per ID
 */
export const getSlideIndexById = (id: string): number => {
  return SLIDES_CONFIG.findIndex((slide) => slide.id === id);
};

/**
 * Slide IDs che mostrano benefici dinamici
 */
export const BENEFIT_SLIDE_IDS = [
  'contact_form',
] as const;

/**
 * Slide IDs per il calcolo del progresso
 */
export const PROGRESS_SLIDE_IDS = SLIDES_CONFIG
  .filter((slide) => slide.type === 'FORM_INPUT')
  .map((slide) => slide.id);


